import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { User } from '../models/user.model';
import { Store } from '@ngrx/store';
import { selectUser } from '../state/auth/auth.selector';

/**
 * Component that provides the basic properties needed for pages.
 */
@Component({
  selector: 'app-page',
  template: ``,
  styles: [],
})
export class PageComponent implements OnInit, OnDestroy {
  // Loading indicator values

  /**
   * Flag to indicate whether the page is loading or not.
   */
  isLoading = false;

  currentUser: User = new User();
  currentUserSub: Subscription;

  /**
   * Sets isLoading to true, indicating that the progress spinner
   * should appear. Subclasses should ensure that they are not
   * rendered until isLoading is set to false (in the subclass),
   * which tells the progress spinner to disappear.
   *
   * @param store The NgRx store used to retrieve user data.
   */
  constructor(store: Store) {
    this.startLoading();
    this.currentUserSub = store.select(selectUser).subscribe((user: User | null) => {
      if (user) {
        this.currentUser = user;
      }
    });
  }

  ngOnInit(): void {}

  ngOnDestroy() {
    this.currentUserSub.unsubscribe();
  }

  /**
   * Sets the isLoading property to true.
   */
  startLoading(): void {
    this.isLoading = true;
  }

  /**
   * Sets the isLoading property to false.
   */
  stopLoading(): void {
    this.isLoading = false;
  }

  get isAdmin(): boolean {
    return this.currentUser.isAdmin;
  }
}
